import styled from '@emotion/styled';
import { RemoveRedEye as FocusIcon } from '@mui/icons-material';

const StyledFocusIcon = styled(FocusIcon)(({ theme }) => ({
  marginRight: 7,
  color: theme.palette.partFocusColor,
}));

export default StyledFocusIcon;
